import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space1 } = theme();

  return StyleSheet.create({
    title: {
      marginRight: space1,
    },
  });
};

export { style };
